import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { recoveringBrowserLock } from "./browser-lock";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL ?? "";
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? "";

// Route bundles and development refreshes must share one browser auth client.
// Multiple clients compete for the same refresh-token lock and subscriptions.
const browser = typeof window === "undefined" ? null : window as Window & {
  __blaundryAuthClient?: { url: string; key: string; client: SupabaseClient };
};
function makeClient() {
  if (!supabaseUrl || !supabaseAnonKey) return null;
  const saved = browser?.__blaundryAuthClient;
  if (saved?.url === supabaseUrl && saved.key === supabaseAnonKey) return saved.client;
  const client = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      ...(browser && typeof navigator !== "undefined" && navigator.locks ? { lock: recoveringBrowserLock() } : {}),
    },
  });
  if (browser) browser.__blaundryAuthClient = { url: supabaseUrl, key: supabaseAnonKey, client };
  return client;
}
export const supabase = makeClient();
